/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 5941:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5671);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(136);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2963);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1120);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7112);
/* harmony import */ var _services_shopify_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9650);
/* harmony import */ var _utils_get_sections__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4331);
/* harmony import */ var _utils_pricing__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9299);
/* harmony import */ var _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4889);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_button_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3709);
/* harmony import */ var _utils_body_lock__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1709);






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var ConfiguratorOverview = /*#__PURE__*/function (_HTMLElement) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(ConfiguratorOverview, _HTMLElement);

  var _super = _createSuper(ConfiguratorOverview);

  function ConfiguratorOverview() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, ConfiguratorOverview);

    _this = _super.call(this);

    var overviewButton = _this.querySelector('.configurator-overview');

    var setDestination = _this.querySelector('.set__products');

    var extraDestination = _this.querySelector('.extra__products');

    var addToCart = _this.querySelector('.js-a2c');

    var a2cButtonText = addToCart.querySelector('.a2c-overview-text');
    var mainProductVariants = document.querySelector('.js-product-variants').innerHTML;

    var extraTitle = _this.querySelector('.extra__title');

    var itemCount = _this.querySelector('#item-count');

    var baseDiscount = _this.dataset.baseDiscount;
    var extraDiscount = _this.dataset.extraDiscount;

    var continueToExtra = _this.querySelector('.js-continue');

    var continueToSummary = _this.querySelector('.js-false');

    var choicePanel = _this.querySelector('.configurator-extra-overlay');

    var nextButton = _this.querySelector('.js-continue');

    var buttonRow = document.querySelector('.button-row__fade');
    console.log('overview loaded'); // Clear initial
    // sessionStorage.removeItem('configuratorConfig');

    var nextLayer = function nextLayer() {
      var nextLayer = nextButton.dataset.next;
      var nextStep = document.querySelector(".layer-".concat(nextLayer));
      var checkmark = document.querySelector(".layer-label-".concat(nextLayer - 1, " .icon-checkmark"));
      var overview = document.querySelector('configurator-overview');

      if (Number(nextLayer) == 5) {
        overview.classList.add('hidden');
      }

      if (Number(nextLayer) >= 5) {
        var buttons = document.querySelectorAll('.button-row__button--hidden');
        buttons.forEach(function (button) {
          button.classList.remove('button-row__button--hidden');
        });
      }

      if (nextStep) {
        nextStep.checked = true;
        nextStep.classList.toggle('active');
        nextStep.parentElement.classList.remove('button-row__button--hidden');
        nextStep.parentElement.classList.remove('button-row__button--no-events'); // checkmark.classList.toggle('icon-checkmark--active')

        var currentPosition = buttonRow.scrollLeft;
        buttonRow.scroll({
          top: 0,
          left: currentPosition + nextStep.nextElementSibling.offsetWidth,
          behavior: 'smooth'
        });
      }
    };

    var isBaseConfigComplete = function isBaseConfigComplete() {
      var configuratorConfig = JSON.parse(sessionStorage.getItem('configuratorConfig'));
      var baseConfig = configuratorConfig.filter(function (product) {
        return product !== null && product.id !== undefined;
      });
      return baseConfig.length >= 3;
    };

    var addDiscount = function addDiscount(discount) {
      if (discount && baseDiscount && extraDiscount) {
        var _discount = (100 - Number(extraDiscount)) / 100;

        return _discount;
      } else {
        var _discount2 = (100 - Number(baseDiscount)) / 100;

        return _discount2;
      }
    };

    var renderProduct = function renderProduct(product, destination) {
      if (product === null) {
        return;
      }

      var productTemplate = "\n        <div class=\"selected-product\">\n          <div class=\"image-holder\">\n            ".concat(product.featured_image ? atob(product.featured_image) : null, "\n          </div>\n          <div class=\"text-holder\">\n            <p class=\"text-holder__title\">").concat(product.product_title.replace(product.option1, ''), "</p>\n            <p class=\"text-holder__option\">").concat(product.option1, "</p>\n            <p class=\"text-holder__size\">").concat(product.product_type.includes('sloop') || product.option2.includes('60X70') || product.option2.includes('65X65') || product.option2.includes('50X75') || product.option2.includes('135') || product.option2.includes('155') || product.option2.includes('80') ? '2X ' + product.option2 : product.option2, "</p>\n          </div>\n          <div class=\"selected-product__price\">\n            <p>\n              <s>").concat((0,_utils_pricing__WEBPACK_IMPORTED_MODULE_9__/* .pricing */ .D)((0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_3__/* .checkForDoublePrice */ .NF)(product)), "</s> \n              ").concat((0,_utils_pricing__WEBPACK_IMPORTED_MODULE_9__/* .pricing */ .D)((0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_3__/* .checkForDoublePrice */ .NF)(product) * addDiscount(product === null || product === void 0 ? void 0 : product.extraProduct)), "\n            </p>\n          </div>\n        </div>\n      ");
      destination.insertAdjacentHTML('beforeend', productTemplate);
    };

    var handleProducts = function handleProducts(config) {
      if (config && config.length > 1) {
        setDestination.innerHTML = '';
        extraDestination.innerHTML = '';
        itemCount.innerHTML = config.length - 1;
        config.forEach(function (product) {
          if (product !== null) {
            product[1] === undefined && product[2] === undefined && product[3] === undefined && product[4] === undefined && product[5] === undefined ? renderProduct(product, setDestination) : null;
            product['5'] !== undefined && product['3'] !== null ? renderProduct(product['5'], extraDestination) : null;
            product['4'] !== undefined && product['3'] !== null ? renderProduct(product['4'], extraDestination) : null;
            product['3'] !== undefined && product['3'] !== null ? renderProduct(product['3'], extraDestination) : null;
            product['2'] !== undefined && product['3'] !== null ? renderProduct(product['2'], extraDestination) : null;
            product['1'] !== undefined && product['3'] !== null ? renderProduct(product['1'], extraDestination) : null;
          }
        });
      }
    };

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          var _configuratorConfig = JSON.parse(sessionStorage.getItem('configuratorConfig'));

          handleProducts(_configuratorConfig);
          (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_3__/* .renderPrice */ .Bw)(_configuratorConfig);

          if (!isBaseConfigComplete()) {
            addToCart.classList.remove('button--primary');
            addToCart.classList.add('button--ghost');
            a2cButtonText.innerHTML = window.product.complete_your_set;
          } else {
            addToCart.classList.remove('button--ghost');
            addToCart.classList.add('button--primary');
            a2cButtonText.innerHTML = window.variantStrings.add_to_cart;
          } // renderPrice(handleDiscountSelection(configuratorConfig), configuratorConfig)
          // handleMainVariant()

        }
      });
    });

    if (overviewButton) {
      observer.observe(overviewButton, {
        attributes: true
      });
    }

    var handleRebuyPricing = function handleRebuyPricing(cartData) {
      var baseTotalElement = document.querySelector('.base-total');
      var extraTotalElement = document.querySelector('.extra-total');
      var baseCompareAtElement = document.querySelector('.base-compareAt');
      var extraCompareAtElement = document.querySelector('.extra-compareAt');
      var totalsDiscountedPriceElement = document.querySelector('.studiosuite-discounted');
      var totalsDiscountedCompareAtElement = document.querySelector('.studosuite-compareat');
      var totalsStudioSuiteDiscountLabelElement = document.querySelector('.studiosuite-label-total');
      var totalPrice = cartData.item.items.reduce(function (acc, item) {
        return acc + item.original_line_price;
      }, 0);
      var baseItems = cartData.item.items.filter(function (item) {
        return item.properties._configuratorItem === 'base';
      });
      var extraItems = cartData.item.items.filter(function (item) {
        return item.properties._configuratorItem === 'extra';
      });
      var basePrice = 0;
      var extraPrice = 0;
      baseItems.forEach(function (item) {
        basePrice += item.price * item.quantity;
      });
      extraItems.forEach(function (item) {
        extraPrice += item.price * item.quantity;
      });
      var discountedBasePrice = basePrice * 0.85;
      var discountedExtraPrice = extraPrice * 0.80;
      var totalDiscount = discountedBasePrice + discountedExtraPrice;
      if (baseTotalElement) baseTotalElement.innerHTML = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_9__/* .pricing */ .D)(discountedBasePrice);
      if (extraTotalElement) extraTotalElement.innerHTML = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_9__/* .pricing */ .D)(discountedExtraPrice);
      if (baseCompareAtElement) baseCompareAtElement.innerHTML = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_9__/* .pricing */ .D)(basePrice);
      if (extraCompareAtElement) extraCompareAtElement.innerHTML = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_9__/* .pricing */ .D)(extraPrice);
      var discountLabel = document.querySelector('.studiosuite-label');
      var discountAmount = document.querySelector('.studiosuite-total-discount');
      if (discountLabel) discountLabel.innerHTML = 'studioSUITE discount';
      if (discountAmount) discountAmount.innerHTML = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_9__/* .pricing */ .D)(totalDiscount - (basePrice + extraPrice));
      if (totalsStudioSuiteDiscountLabelElement) totalsStudioSuiteDiscountLabelElement.innerHTML = totalsStudioSuiteDiscountLabelElement.dataset.title;
      if (totalsDiscountedCompareAtElement) totalsDiscountedCompareAtElement.innerHTML = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_9__/* .pricing */ .D)(totalPrice);
      if (totalsDiscountedPriceElement) totalsDiscountedPriceElement.innerHTML = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_9__/* .pricing */ .D)(totalDiscount);
    }; // initial load


    var configuratorConfig = JSON.parse(sessionStorage.getItem('configuratorConfig'));
    handleProducts(configuratorConfig);
    addToCart.addEventListener('click', function () {
      if (!isBaseConfigComplete()) {
        addToCart.classList.remove('button--primary');
        addToCart.classList.add('button--ghost');
        a2cButtonText.innerHTML = window.product.complete_your_set;
        return;
      } else {
        addToCart.classList.remove('button--ghost');
        addToCart.classList.add('button--primary');
        a2cButtonText.innerHTML = window.variantStrings.add_to_cart;
      }

      _utils_button_state__WEBPACK_IMPORTED_MODULE_5__/* ["default"].loading */ .Z.loading(addToCart); // get the items again after each a2c click

      var configuratorConfig = JSON.parse(sessionStorage.getItem('configuratorConfig'));
      var setProducts = configuratorConfig.filter(function (product) {
        return product !== null && product.id !== undefined;
      });
      var cartSections = (0,_utils_get_sections__WEBPACK_IMPORTED_MODULE_10__/* .getCartSectionsToRender */ .j)().map(function (section) {
        return section.section;
      });

      var sectionId = _this.closest('.shopify-section').id;

      var sections = cartSections.push('configurator-product');
      var structuredData = {
        items: [configuratorConfig[4] && configuratorConfig[4][1] ? {
          id: configuratorConfig[4][1].id,
          quantity: 1,
          discount_as: 'extra',
          properties: {
            _configuratorItem: 'extra'
          }
        } : null, configuratorConfig[4] && configuratorConfig[4][2] ? {
          id: configuratorConfig[4][2].id,
          quantity: 1,
          discount_as: 'extra',
          properties: {
            _configuratorItem: 'extra'
          }
        } : null, configuratorConfig[4] && configuratorConfig[4][3] ? {
          id: configuratorConfig[4][3].id,
          quantity: 2,
          discount_as: 'extra',
          properties: {
            _configuratorItem: 'extra'
          }
        } : null, configuratorConfig[4] && configuratorConfig[4][4] ? {
          id: configuratorConfig[4][4].id,
          quantity: 1,
          discount_as: 'extra',
          properties: {
            _configuratorItem: 'extra'
          }
        } : null, configuratorConfig[4] && configuratorConfig[4][5] ? {
          id: configuratorConfig[4][5].id,
          quantity: 1,
          discount_as: 'extra',
          properties: {
            _configuratorItem: 'extra'
          }
        } : null],
        sections: (0,_utils_get_sections__WEBPACK_IMPORTED_MODULE_10__/* .getCartSectionsToRender */ .j)().map(function (section) {
          return section.section;
        }),
        sections_url: window.location.pathname,
        attributes: {
          _configuratorItem: 'base',
          _configuratorUrl: window.location.pathname + window.location.search,
          _configuratorExtra: configuratorConfig[4] !== undefined ? 'extra' : null
        }
      };
      setProducts.forEach(function (selectedVariant) {
        structuredData.items.push({
          id: selectedVariant.id,
          quantity: selectedVariant.product_title.includes('sloop') || selectedVariant.option2.includes('140') || selectedVariant.option2.includes('90') || selectedVariant.option2.includes('60X70') || selectedVariant.option2.includes('65X65') || selectedVariant.option2.includes('50X75') || selectedVariant.option2.includes('50') || selectedVariant.option2.includes('135') || selectedVariant.option2.includes('155') ? 2 : 1,
          discount_as: 'base',
          properties: {
            _configuratorItem: 'base',
            _minSize: selectedVariant.product_title.includes('sloop') || selectedVariant.option2.includes('140') || selectedVariant.option2.includes('90') || selectedVariant.option2.includes('60X70') || selectedVariant.option2.includes('65X65') || selectedVariant.option2.includes('50X75') || selectedVariant.option2.includes('50') || selectedVariant.option2.includes('135') || selectedVariant.option2.includes('155') ? 2 : 1
          }
        });
      });
      structuredData.baseItems = structuredData.items.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.discount_as) === 'base';
      });
      structuredData.extraItems = structuredData.items.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.discount_as) === 'extra';
      });
      structuredData.base_discount_amount = Number(addToCart.dataset.baseDiscount) / 100;
      structuredData.extra_discount_amount = Number(addToCart.dataset.extraDiscount) / 100;
      var makeArray = structuredData;
      makeArray.items = makeArray.items.filter(function (product) {
        return product != null;
      });
      console.log();
      var selectedItems = JSON.parse(sessionStorage.getItem('configuratorConfig'));
      var filteredItems = selectedItems.filter((selectedItem) => selectedItem !== null);
      var items = [];

    //   var selected_items = [];
    //   if (selectedItems != null) {
    //   filteredItems.forEach(function(val, index){

    //     if( Object.entries(val)[0][1].extraProduct == true){
    //       for (let i in val) {
    //                 var v = val[i];
    //                 if (v && v.product_title && v.option1 && v.option2) {
    //                   selected_items.push({
    //                         "title": v.product_title,
    //                         "select_colour": v.option1,
    //                         "select_size": v.option2
    //                     });
    //                 }
    //             }
    //     } else {
    //       selected_items.push({
    //             "title": val.product_title,
    //             "select_colour":val.option1,
    //             "select_size":val.option2
    //         });
    //     }
    // });
    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   event: 'configuratorItemsSelected',
    //   ecommerce: {
    //       items:selected_items
    //   }
    // });
    if (selectedItems != null) {

      filteredItems.forEach(function(val, index){

          if( Object.entries(val)[0][1].extraProduct == true){
            for (let i in val) {
                      var v = val[i];
                      if (v && v.product_title && v.option1 && v.option2) {
                          items.push({
                              "title": v.product_title,
                              "select_colour": v.full_option1,
                              "select_size": v.full_option2,
                              "price": val.price
                          });
                      }
                  }
          } else {
              items.push({
                  "title": val.product_title,
                  "select_colour":val.full_option1,
                  "select_size":val.full_option2,
                  "price": val.price
              });
          }
      });


      window.dataLayer.push({
        event: 'studiosuite_addToCart',
        ecommerce: {
          currencyCode: 'USD', 
          add: {
            items: items
          }
        }
      });

      window.dataLayer = window.dataLayer.filter(item => {

        if (Array.isArray(item)) {
          return !(item[0] === 'event' && item[0] === 'add_to_cart' && item[2]?.send_to);
        }

        return !(item.event && item.send_to);
      });

    }
      makeArray.items.forEach(function (item) {
        item.gid = "\"gid://shopify/ProductVariant/".concat(item.id, "\"");
      });
      axios__WEBPACK_IMPORTED_MODULE_4___default().post('https://hook.eu2.make.com/vdjr7zf2bcw8to4vu1k38m83vwadxzst', makeArray).then(function (response) {
        var _response$data;

        document.cookie = "discount_code=".concat(response.data.base_discount_code, "; path=/");
        document.cookie = "discount_base_id=".concat(response.data.discount_base_id, "; path=/");
        document.cookie = "discount_extra_id=".concat(response.data.discount_extra_id, "; path=/");
        document.cookie = "discount_extra_code=".concat(response.data.extra_discount_code, "; path=/");
        document.cookie = "discount_base_code=".concat(response.data.base_discount_code, "; path=/");
        var param = "".concat(response.data.base_discount_code).concat((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.extra_discount_code ? "," + response.data.extra_discount_code : "");
        var url = window.location.href.toString();
        var discountUrl = "/discount/".concat(param);
        var Cart = window.Rebuy.Cart;
        Cart.addItem(structuredData);
        Cart.setDiscount(response.data.base_discount_code);
        Cart.setDiscount(response.data.extra_discount_code);
        document.addEventListener('rebuy:cart.add', function (event) {
          setTimeout(function () {
            handleRebuyPricing(event.detail);
          }, 2000);
        });
        document.addEventListener('rebuy:cart.change', function (event) {
          var items = event.detail.cart.getItems();
          console.log(event);
          handleRebuyPricing({
            item: {
              items: items
            }
          });
        });
        _utils_button_state__WEBPACK_IMPORTED_MODULE_5__/* ["default"].finishedLoading */ .Z.finishedLoading(addToCart);
      }); // const firstSlide = document.querySelector('.bedsheet')
      // const firstButton = document.querySelector('.button-row__button .layer-1')
      // const lastSlide = document.querySelector('.overview')
      // const scrollContainer = document.querySelector('.button-row__fade')
      // scrollContainer.scrollLeft = 0
      // firstSlide.classList.remove('hidden')
      // firstButton.checked = true
      // lastSlide.classList.add('hidden')
      // window.scrollTo(0,0)
    });

    if (continueToExtra && continueToSummary) {
      var url = new URL(window.location.href);
      var params = url.searchParams;
      var hasPreloadedConfig = false;
      params.forEach(function (value, key) {
        if (key === 'bedsheet' || key === 'cover' || key === 'pillowcase') {
          hasPreloadedConfig = true;
        }
      });

      if (hasPreloadedConfig) {
        var layerThree = document.querySelector('.layer-3-button'); // const overlay = document.querySelector('.configurator-extra-overlay')
        // overlay.remove()

        layerThree.dataset.next = 5;
        choicePanel.classList.add('hidden');
        extraTitle.style.display = 'block'; // nextLayer()
      }

      continueToExtra.addEventListener('click', function () {
        var layerThree = document.querySelector('.layer-3-button');
        layerThree.dataset.next = 5;
        choicePanel.classList.toggle('hidden');
        extraTitle.style.display = 'block';
        nextLayer();
      });
      continueToSummary.addEventListener('click', function () {
        choicePanel.classList.toggle('hidden');

        var selectedItems = JSON.parse(sessionStorage.getItem('configuratorConfig'));
        var filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];

        var selected_items = [];

        filteredItems.forEach(function(val){
          if (Object.entries(val)[0][1].extraProduct === true) {
            for (let i in val) {
              var v = val[i];
              if (v && v.product_title && v.option1 && v.option2) {
                selected_items.push({
                  title: v.product_title,
                  select_colour: v.full_option1,
                  select_size: v.full_option2
                });
              }
            } 
          } else {
            selected_items.push({
              title: val.product_title,
              select_colour: val.full_option1,
              select_size: val.full_option2
            });
          }
        });

        window.dataLayer = window.dataLayer || [];

        // Check if exact same ecommerce.items already pushed
        const alreadyPushed = window.dataLayer.some(entry =>
          entry.event === 'configuratorItemsSelected' &&
          JSON.stringify(entry.ecommerce?.items) === JSON.stringify(selected_items)
        );

        if (!alreadyPushed) {
          window.dataLayer.push({
            event: 'configuratorItemsSelected',
            ecommerce: {
              items: selected_items
            }
          });
        }

      });

      var showAllButtons = function showAllButtons() {
        var buttons = document.querySelectorAll('.button-row__button');
        buttons.forEach(function (button) {
          button.classList.remove('button-row__button--hidden');
        });
      };

      var handleCheckedButtons = function handleCheckedButtons() {
        var url = new URL(window.location.href);
        var params = url.searchParams;
        params.forEach(function (value, key) {
          var label = document.querySelector("label[for=\"".concat(key, "\"]"));
          var svg = label === null || label === void 0 ? void 0 : label.querySelector('svg');
          var button = label === null || label === void 0 ? void 0 : label.closest('.button-row__button');
          label === null || label === void 0 ? void 0 : label.classList.add('handled');
          svg === null || svg === void 0 ? void 0 : svg.classList.add('icon-checkmark--active');

          if (label) {
            showAllButtons();
          }
        });
        var backButton = document.querySelector('.show-overview');
        var starter = document.querySelector('.studiosuite-starter');
        var innerContainer = document.querySelector('.main-product__inner--configurator');
        backButton.addEventListener('click', function () {
          starter.classList.remove('studiosuite-starter--hidden');

          _this.classList.remove('main-product__inner--configurator-active');

          innerContainer.classList.remove('main-product__inner--configurator-active');
          _utils_body_lock__WEBPACK_IMPORTED_MODULE_6__/* ["default"].lock */ .Z.lock();
        });
      };

      setTimeout(function () {
        handleCheckedButtons();
      }, 200);
    }

    return _this;
  }

  return ConfiguratorOverview;
}( /*#__PURE__*/(0,_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(HTMLElement));

if (customElements.get('configurator-overview') === undefined) {
  customElements.define('configurator-overview', ConfiguratorOverview);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	!function() {
/******/ 		__webpack_require__.j = 3031;
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			3031: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkworkflow"] = self["webpackChunkworkflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [1216], function() { return __webpack_require__(5941); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;